export default "__VITE_ASSET__DMVqt9co__"